import { styled } from '@mui/material/styles';
import MuiButton from '@mui/material/Button';
var Button = styled(MuiButton)({
    borderRadius: '8px'
});
export default Button;
